export const getNewEmptyTimesheetEntryPerActivity = (activityId) => {
  return {
    id: activityId,
    activityId: null,
    dayActivityLinks: Array(7)
      .fill()
      .map(() => ({ manHours: 0 }))
  };
};
